var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1,6h6c1.7,0,3-1.3,3-3s-1.3-3-3-3c-.6,0-1,.4-1,1s.4,1,1,1,1,.4,1,1-.4,1-1,1H0v2h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16,2c-1.7,0-3.2,1.1-3.8,2.7-.2.5.1,1.1.6,1.3.5.2,1.1-.1,1.3-.6.3-.9,1.1-1.4,1.9-1.4,1.1,0,2,.9,2,2s-.9,2-2,2H0v2h16c2.2,0,4-1.8,4-4s-1.8-4-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12,12H0v2h12c1.1,0,2,.9,2,2s-.9,2-2,2c-.8,0-1.6-.5-1.9-1.3-.2-.5-.8-.8-1.3-.6-.5.2-.8.8-.6,1.3.6,1.6,2.1,2.7,3.8,2.7,2.2,0,4-1.8,4-4h0c0-2.3-1.8-4.1-4-4.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindy);
export default __webpack_public_path__ + "static/media/windy.5c780f1734dbae05a8055f6e55d7b224.svg";
export { ForwardRef as ReactComponent };